import { Toolbar } from "@components-common/toolbar";
import { FC, useEffect, useState } from "react";
import { ReviewConfiguration, ReviewConfigurationContent } from "./steps/5-review-config/ReviewConfiguration";
import { application } from "../../../_runtime/bootstrap";
import { useParams } from "react-router-dom";
import { getDataFromFile } from "../specifications/_helpers";

export const ReviewConfigPage: FC = ({ ...props }) => {
  const { buildingConfigId } = useParams();
  const [configuration, setConfiguration] = useState<any>(undefined);

  useEffect(() => {
    application
      .getHttpClient()
      .get(`buildingsconfigms/configurations/${buildingConfigId}`)
      .then(async (response: any) => {
        await getDataFromFile(response.body.url, (data: any) => {
          data.info = {
            ...data.info,
            height: data.height,
            numberOfLevels: data.numberOfLevels,
          };
          data.elements = data.elementTypes;

          delete data.height;
          delete data.numberOfLevels;
          delete data.elementTypes;
          setConfiguration(data);
        });
      });
  }, []);

  return (
    <>
      <Toolbar right={["back"]} />
      {configuration !== undefined && (
        <ReviewConfigurationContent {...configuration} />
      )}
    </>
  );
};
